import { render, staticRenderFns } from "./Suites.vue?vue&type=template&id=c3c2d166&scoped=true&"
import script from "./Suites.vue?vue&type=script&lang=js&"
export * from "./Suites.vue?vue&type=script&lang=js&"
import style0 from "./Suites.vue?vue&type=style&index=0&id=c3c2d166&lang=scss&scoped=true&"
import style1 from "./Suites.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3c2d166",
  null
  
)

export default component.exports